import { Fragment, h } from 'preact';
import { FeebackConst } from '../../../constants/settingsConsts';

export function HelpfulFeedbackSection(props : any) {
    const feedbackType = props?.msgData?.feedbackType;
    const feedbackData = props?.msgData?.feedbackData;
    const languageData = props?.hostInstance?.languagedata
    return (
        <div className="form-feedback-div" role="contentinfo">
            <div className="feedback-wrapper" role="contentinfo">
                <div className="feedback-actions-info" role="contentinfo">
                    <div className="left-sec-info" role="contentinfo">
                        {(feedbackType === FeebackConst.DIALOGS || feedbackType === FeebackConst.SUMMARY) && (
                            <>
                                <div className="icon_block" role="contentinfo">
                                    {/* <img src="/src/assets/images/logo/gifLoader.gif" alt="Gif Image" /> */}
                                    <svg width="24" height="24" viewBox="0 0 15 15" fill="none">
                                        <g clip-path="url(#clip0_3293_193076)">
                                            <path d="M1 6.15278L1 9.09722M4.3125 3.20833L4.3125 12.0417M7.625 1V14.25M10.9375 3.20833V12.0417M14.25 6.15278V9.09722" stroke="url(#paint0_linear_3293_193076)" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <linearGradient id="paint0_linear_3293_193076" x1="2.94042" y1="12.3096" x2="12.3096" y2="2.94042" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#528BFF" />
                                                <stop offset="1" stop-color="#F670C7" />
                                            </linearGradient>
                                            <clipPath id="clip0_3293_193076">
                                                <rect width="15" height="15" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                </div>
                                <h1>{`${languageData?.HELP_FULL}`}</h1>
                            </>)
                        }
                        <button aria-label="Button" value="like" className={`feedback-btn-thumb aa-feedback-positive ${feedbackData?.feedback === 'like' ? 'active-feedback-btn' : ''}`}>
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
                                <g clip-path="url(#clip0_9619_82516)">
                                    <path opacity="0.12" d="M1 6.70001V10.2C1 10.7523 1.44772 11.2 2 11.2H3.5V5.70001H2C1.44772 5.70001 1 6.14773 1 6.70001Z" fill="#101828" />
                                    <path d="M3.5 11.2V5.70001M1 6.70001V10.2C1 10.7523 1.44772 11.2 2 11.2H8.71312C9.45348 11.2 10.0831 10.6598 10.1957 9.9281L10.7341 6.4281C10.8739 5.51946 10.1709 4.70001 9.25158 4.70001H7.5C7.22386 4.70001 7 4.47615 7 4.20001V2.43293C7 1.75201 6.448 1.20001 5.76708 1.20001C5.60467 1.20001 5.45749 1.29566 5.39153 1.44407L3.63197 5.40308C3.55172 5.58365 3.37266 5.70001 3.17506 5.70001H2C1.44772 5.70001 1 6.14773 1 6.70001Z" stroke="#101828" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_9619_82516">
                                        <rect width="12" height="12" fill="white" transform="translate(0 0.200012)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                        <button aria-label="Button" value="dislike" className={`feedback-btn-thumb aa-feedback-negative ${feedbackData?.feedback === 'dislike' ? 'active-feedback-btn' : ''}`}>
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
                                <g clip-path="url(#clip0_9619_153041)">
                                    <path opacity="0.12" d="M9.4 1.20001H8.5V6.70001H9.4C9.96005 6.70001 10.2401 6.70001 10.454 6.59102C10.6422 6.49515 10.7951 6.34216 10.891 6.154C11 5.94009 11 5.66006 11 5.10001V2.80001C11 2.23996 11 1.95993 10.891 1.74602C10.7951 1.55786 10.6422 1.40488 10.454 1.30901C10.2401 1.20001 9.96005 1.20001 9.4 1.20001Z" fill="#101828" />
                                    <path d="M8.49954 1.20001V6.70001M10.9995 5.10001V2.80001C10.9995 2.23996 10.9995 1.95993 10.8905 1.74602C10.7947 1.55786 10.6417 1.40488 10.4535 1.30901C10.2396 1.20001 9.95959 1.20001 9.39954 1.20001H4.05854C3.3278 1.20001 2.96243 1.20001 2.66733 1.33373C2.40724 1.45158 2.18619 1.64122 2.03016 1.88037C1.85312 2.15171 1.79757 2.51283 1.68645 3.23507L1.42491 4.93507C1.27836 5.88767 1.20508 6.36397 1.34644 6.73457C1.47051 7.05986 1.70386 7.33186 2.0065 7.50395C2.3513 7.70001 2.8332 7.70001 3.79701 7.70001H4.19954C4.47956 7.70001 4.61958 7.70001 4.72653 7.75451C4.82061 7.80245 4.8971 7.87894 4.94504 7.97302C4.99954 8.07997 4.99954 8.21999 4.99954 8.50001V9.96709C4.99954 10.648 5.55154 11.2 6.23246 11.2C6.39487 11.2 6.54205 11.1044 6.60801 10.956L8.28839 7.1751C8.36482 7.00314 8.40303 6.91715 8.46344 6.85411C8.51683 6.79838 8.5824 6.75576 8.65501 6.72961C8.73716 6.70001 8.83125 6.70001 9.01944 6.70001H9.39954C9.95959 6.70001 10.2396 6.70001 10.4535 6.59102C10.6417 6.49515 10.7947 6.34216 10.8905 6.154C10.9995 5.94009 10.9995 5.66006 10.9995 5.10001Z" stroke="#101828" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_9619_153041">
                                        <rect width="12" height="12" fill="white" transform="translate(0 0.200012)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                        <button className={`feedback-btn-arrow aa-negative-feedback-dropdown-btn ${feedbackData?.feedback === 'dislike' && feedbackData?.suggestionType !== 'summary' ? 'active-feedback-btn-rotate' : ''} ${feedbackData?.feedback !== 'dislike' ? 'aa-hidden' : ''}`} aria-label="Button">
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.36437 10.3494C8.17497 10.5383 7.87481 10.5494 7.67239 10.3828L7.63563 10.3494L3.15093 6.07722C2.94969 5.87653 2.94969 5.55115 3.15093 5.35047C3.34033 5.16158 3.64048 5.15047 3.84291 5.31713L3.87967 5.35047L8 9.25923L12.1203 5.35047C12.3097 5.16158 12.6099 5.15047 12.8123 5.31713L12.8491 5.35047C13.0385 5.53935 13.0496 5.83868 12.8825 6.04056L12.8491 6.07722L8.36437 10.3494Z" fill="#9AA4B2" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function NegativeFeedbackSection(props : any) {

    const suggestionList = props?.msgData?.suggestionList;
    const showComments = props?.msgData?.showComments; 
    const feedbackData = props?.msgData?.feedbackData;
    const languageData = props?.hostInstance?.languagedata

    return (
        <div className={`improve-feedback-block aa-negative-feedback-box ${feedbackData?.feedback !== 'dislike' || feedbackData?.suggestionType == 'summary' ? 'aa-hidden' : ''}`} role="contentinfo">
            <div className="improve-options-text">
                {suggestionList?.map((suggestion : string, index : number) => {
                    let active = feedbackData?.feedbackDetails?.find((item : string) => item === suggestion);                    
                    return (
                        <button aria-label="Button" value={`${suggestion}`} className={`improve-lable-text feedback-suggestion-${props.msgData?.dialogId}-${index} ${active ? 'active-improve-btn' : ''}`}>{suggestion}</button>
                    )
                })}
              
            </div>
            <div className={`input-improve-text ${showComments ? '' : 'aa-hidden'}`}>
                <textarea maxLength={150} placeholder={`${languageData?.TELL_US_MORE}…`} className={`input-control aa-feeback-comment-${props.msgData?.dialogId}`} value={feedbackData?.comment || ''}></textarea>
            </div>
            <div className="submit-count-text">
                <p className={`aa-feedback-comment-count ${showComments ? '' : 'aa-hidden'}`}>{feedbackData?.comment?.length || 0}/150</p>
                <button className="send-btn-feedback aa-feedback-submit" aria-label="Button">{languageData?.SUBMIT}</button>
            </div>
        </div>
    )
}


export function OverallFeedbackSection(props : any) {
    let suggestionList: any = [];
    if(props?.msgData?.isDefaultSuggestionList) {
        suggestionList = props?.msgData?.suggestionList;
    } else {
        suggestionList = props?.msgData?.suggestionList?.map((item: any) => item?.key);
    }
    const showComments = props?.msgData?.showComments;
    const languageData = props?.hostInstance?.languagedata;
    const widgetFeedbackData = props?.hostInstance.rootService.widgetFeedbackData;
    const widgetHistoryType = props?.hostInstance.rootService.widgetHistoryType

    return (
        <div className={`form-feedback-info aa-radius-8 aa-${props?.msgData?.type}-feedback-info`}>
            <div className="improve-feedback-block d-flex a-flex-column a-gap-4 a-width-100">
            <div className="aa-text-xs medium a-mb-8">{languageData?.FEEDBACK_PROVIDE_REASONS}</div>
            <div className="improve-options-text a-width-100">
            {
                suggestionList?.map((suggestion : string, index : number) => {
                    return (
                        <button aria-label="Button" value={`${suggestion}`} className={`improve-lable-text aa-widget-feedback-suggestion-${props.msgData?.type}-${index} aa-${props?.msgData?.type}-feedback ${widgetFeedbackData.selectedSuggestions.includes(suggestion) ? 'active-improve-btn' : ''}`}>{suggestion}</button>
                    )
                })
            }
            </div>
            <div className={`input-improve-text ${showComments ? '' : 'aa-hidden'}`}>
                <textarea maxLength={150} placeholder={`${languageData?.TELL_US_MORE}…`} className={`input-control aa-text-xs aa-feeback-comment-${props.msgData?.type}`} value={props?.msgData?.type === widgetHistoryType ?  widgetFeedbackData.comment : ''}></textarea>
            </div>
            <div className="submit-count-text">
                <p className={`aa-feedback-comment-count-${props?.msgData?.type} ${showComments ? '' : 'aa-hidden'}`}>{widgetFeedbackData?.comment?.length || 0}/150</p>
            </div>
        </div>
        </div>
    )
}